import { CommonModule } from "@angular/common";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TwoFactorAuthModalComponent } from './two-factor-auth-modal.component';
import { DenyModalComponent } from './deny-modal/deny-modal.component';
import { PromptModalComponent } from './prompt-modal/prompt-modal.component';
import { VerifyCodeModalComponent } from './verify-code-modal/verify-code-modal.component'
import { TwoFactorAuthService } from "./two-factor-auth.service";
import { UtilitiesModule } from '../../utilities/utilities.module';
import { PipesModule } from "../../utilities/pipes/pipes.module";

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, UtilitiesModule, PipesModule],
  providers: [CookieService, TwoFactorAuthService],
  declarations: [
    TwoFactorAuthModalComponent,
    DenyModalComponent,
    PromptModalComponent,
    VerifyCodeModalComponent
  ],
  exports: [
    TwoFactorAuthModalComponent,
    DenyModalComponent,
    PromptModalComponent,
    VerifyCodeModalComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TwoFactorModule {
  constructor() {}
}
